const isDevBranch = process.env.CIRCLE_BRANCH === 'dev';

const apiKey = isDevBranch ? process.env.REACT_APP_FIREBASE_API_KEY_DEV : process.env.REACT_APP_FIREBASE_API_KEY;
const authDomain = isDevBranch ? process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
const databaseURL = isDevBranch ? process.env.REACT_APP_FIREBASE_DATABASE_URL_DEV : process.env.REACT_APP_FIREBASE_DATABASE_URL;
const projectId = isDevBranch ? process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV : process.env.REACT_APP_FIREBASE_PROJECT_ID;
const storageBucket = isDevBranch ? process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV : process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
const messagingSenderId = isDevBranch ? process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DEV : process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
const appId =  isDevBranch ? process.env.REACT_APP_FIREBASE_APP_ID_DEV : process.env.REACT_APP_FIREBASE_APP_ID;

export default {
  apiKey,
  authDomain,
  databaseURL,
  projectId,
  storageBucket,
  messagingSenderId,
  appId
};